import axios from "axios";
import { authService } from "./../services/authService";
import "./../utils/authConst";
import qs from "qs";
import { IDENTITY_CONFIG } from "../utils/authConst";

axios.interceptors.request.use(
  (config) => {
    const token = authService.getAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response) {
      const originalRequest = error.config;
      if (
        error.response.status === 401 &&
        originalRequest.url ===
          IDENTITY_CONFIG.protocol +
            IDENTITY_CONFIG.baseApiUrl +
            "connect/token"
      ) {
        throw error;
      }

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = authService.getRefreshToken();
        return axios({
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
          method: "POST",
          baseApiUrl: IDENTITY_CONFIG.protocol + IDENTITY_CONFIG.baseApiUrl,
          url: "/connect/token",
          data: qs.stringify({
            grant_type: "refresh_token",
            refresh_token: refreshToken,
            client_id: "asdf",
          }),
        }).then(async (res) => {
          if (res) {
            await authService.setToken(res);
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + authService.getAccessToken();
            return axios(originalRequest);
          }
        });
      }

      throw error;
    } else {
      throw error;
    }
  }
);
